import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';

import { SubscriptionSearchService } from '~/attendee/service/subscription-search.service';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { ActivityService } from '~/core/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

export const OrganizerSharedActivityAndTimeslotsResolver: ResolveFn<{
  activity: Activity;
  timeslots: Timeslot[];
}> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  activityService: ActivityService = inject(ActivityService),
  organizationService: OrganizerSharedOrganizationService = inject(
    OrganizerSharedOrganizationService
  ),
  subscriptionSearchService: SubscriptionSearchService = inject(
    SubscriptionSearchService
  )
): Observable<{ activity: Activity; timeslots: Timeslot[] }> => {
  const activityId = route.paramMap.get('id');
  const organization = organizationService.organization;

  return activityService.getActivity(activityId).pipe(
    tap((activity) => {
      if (activity.organizationIdentifier !== organization.identifier) {
        throw new Error('Unauthorized');
      }
    }),
    mergeMap((activity) =>
      activityService
        .getActivityTimeslots(
          activity.sku.toString(),
          subscriptionSearchService.getTimeslotsFilters(),
          1,
          20
        )
        .pipe(
          map((timeslots) => ({
            activity,
            timeslots,
          }))
        )
    )
  );
};
